export const ACTIONS_RECIPIENT = {
  INVALIDATE: 'RECIPIENTS_INVALIDATE',
  RECEIVE: 'RECIPIENTS_RECEIVE',
  DELETE: 'RECIPIENT_DELETE',
  UPDATE: 'RECIPIENT_UPDATE',
};

// NOTE: This can go once components are all converted
const recipientConstants = {};

export default recipientConstants;
